// src/trello/card/types.ts
var TrelloCardAriResourceOwner = "trello", TrelloCardAriResourceType = "card";

export {
  TrelloCardAriResourceOwner,
  TrelloCardAriResourceType
};
